export default "__VITE_ASSET__jNBNKY6H__"